module.exports = __webpack_public_path__ + "media/images/lp_v6_img22-4d6417550ea71989f3fac07cce2774dc.webp";